import { render, staticRenderFns } from "./TicketGroupBenefits.vue?vue&type=template&id=368330d7&scoped=true"
import script from "./TicketGroupBenefits.vue?vue&type=script&lang=js"
export * from "./TicketGroupBenefits.vue?vue&type=script&lang=js"
import style0 from "./TicketGroupBenefits.vue?vue&type=style&index=0&id=368330d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368330d7",
  null
  
)

export default component.exports